import type { TableItem } from '../../common/Table';

export interface SellerManagementRow extends TableItem {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string | null;
  isActive: boolean;
  locationId: number | null;
  locationName: string | null;
  totalSales: number;
  salesCount: number;
}

export interface SellerManagementFiltersState {
  searchTerm: string;
  locationId: string;
  saleDateFrom: string;
  saleDateTo: string;
}

export const emptySellerManagementFilters = (): SellerManagementFiltersState => ({
  searchTerm: '',
  locationId: '',
  saleDateFrom: '',
  saleDateTo: '',
});
